module.exports = __webpack_public_path__ + "img/Big_Taxes-256.831e0dbc.png";